<onboarding-container [loading]="false" [hideLogout]="true" [hideForward]="true" [hideBack]="true">
  <div class="zero-text p-huge-med">{{ 'onboarding.redirect.headline' | transloco }}</div>
  <div class="mt-2 zero-text p-base-reg" [innerHTML]="'onboarding.redirect.text' | transloco"></div>
</onboarding-container>
